import React, { Component } from 'react'
import { Button, Modal, Table, Pagination } from 'react-bootstrap'
import cn from 'classnames'

class UserWordsManage extends Component {
  getClasses = (message) => {
    const bsStyle = cn({
      'alert-success': message.type === 'success' ? true : false,
      'alert-info': message.type === 'info' ? true : false,
      'alert-warning': message.type === 'warning' ? true : false,
      'alert-danger': message.type === 'danger' ? true : false,
      'show': !message.showed ? true : false,
      'hide': message.showed ? true : false,
      'alert': true,
      'alert-dismissible': true,
    });

    return bsStyle;
  }

  render() {
    const words = this.props.userWords;
    const paginationCur = this.props.paginationCur;
    const paginationStep = this.props.paginationStep;

    const sliceParam1 = paginationCur * paginationStep;
    const sliceParam2 = paginationCur * paginationStep + paginationStep;

    const paginationLastVal = Math.ceil(words.length/paginationStep) - 1;

    const checkedUserWordsIds = words.reduce((acc, word) => word.checked ? [...acc, word.userWordId] : acc, []);
    const countChecked = checkedUserWordsIds.length;

    const messages = this.props.messages;

    return (
      <div>
        <Modal show={this.props.modalState === 'close' ? false : true}>
          <Modal.Header closeButton onHide={this.props.toggleUserWordsManageModal}>
            <Modal.Title>Управление словами</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            {words.length === 0 ? null :
              (
                <div className="text-center">
                  <Pagination bsSize="large" style={{margin: '10px 0'}}>
                    <Pagination.First onClick={() => this.props.userWordsManageSetPagination({paginationCur: 0})} />
                    <Pagination.Prev onClick={() => this.props.userWordsManageSetPagination({paginationCur: paginationCur > 0 ? paginationCur - 1 : paginationCur})} />
                    <Pagination.Next onClick={() => this.props.userWordsManageSetPagination({paginationCur: paginationCur < paginationLastVal ? paginationCur  + 1 : paginationCur})}/>
                    <Pagination.Last onClick={() => this.props.userWordsManageSetPagination({paginationCur: paginationLastVal})}/>
                  </Pagination>
                </div>
              )
            }

            {words.length === 0 ?
              <div className="alert alert-info" role="alert">У вас пока нет слов.</div>
              : (
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th className="col-md-1"></th>
                      <th className="col-md-1">#</th>
                      <th className="col-md-4">Слово</th>
                      <th className="col-md-5">Перевод</th>
                      <th className="col-md-1">lvl</th>
                    </tr>
                  </thead>
                  <tbody>
                    {words.slice(sliceParam1, sliceParam2).map((word, index) => {
                      return (
                        <tr key={word.userWordId} className={word.checked ? 'success' : null} onClick={() => this.props.userWordsManageCheckWord({ userWordId: word.userWordId })}>
                          <td className="text-center">
                            <input
                              type="checkbox"
                              checked={word.checked}
                              value={word.wordId}
                            />
                          </td>
                          <td>{sliceParam1 + index + 1}</td>
                          <td>{word.wordValue}</td>
                          <td>{word.wordTranslate}</td>
                          <td>{word.score}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )
            }

            {messages.map(
              (message, id) => (
                <div key={id} className={this.getClasses(message)}>
                  <button onClick={() => this.props.hideMessageUserWordsManage({id})} type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  {message.text}
                </div>
              )
            )}

            <div className="text-right">
                <Button onClick={() => this.props.deleteUserWords(checkedUserWordsIds)} bsStyle="danger" title={words.length - 10 <= countChecked ? 'Невозможно удалить слова. В словаре должно быть не менее 10 слов.' : ''} disabled={words.length - 10 <= countChecked || countChecked < 1 || this.props.isRequest ? true : false}>
                  <span className="glyphicon glyphicon-trash"></span> Удалить <span className="badge">{countChecked}</span>
                </Button>&nbsp;
                <Button disabled={this.props.isRequest ? true : false} bsStyle="primary" onClick={this.props.toggleUserWordsManageModal}>Закрыть</Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default UserWordsManage;



// WEBPACK FOOTER //
// ./src/components/UserWordsManage.js